export const css = /* css */ `
:host,
:host *,
*::before,
*::after {
  box-sizing: border-box;
}
a {
  color: inherit;
}
:not(.focus-visible),
:host(:not(.focus-visible)) {
  outline: none;
}
[hidden] {
  display: none !important;
}
:host {
  font-size: 0;
}
`;